import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

function SideBar(props) {
  const { pages, directMessagesUnseen, directMessagesSubscribe, directMessagesUnsubscribe } = props
  useEffect(() => {
    directMessagesSubscribe()
    return () => {
      directMessagesUnsubscribe()
    }
  }, [])

  const audioNotification = (type) => {
    const audio = new Audio(`/audios/${type}_message.mp3`)
    audio.play()
  }

  useEffect(() => {
    if (props.directUnseenIncreased) audioNotification('direct')
  }, [props.directUnseenIncreased])

  useEffect(() => {
    if (props.groupUnseenIncreased) audioNotification('group')
  }, [props.groupUnseenIncreased])

  const pageLinks = () => {
    return Object.keys(pages).map((pageName, index) => {
      const page = pages[pageName]
      return <li key={index}>
        <a className={page.active ? 'active' : ''} href={page.path}>
          <div className={'sidebar-menu__item-icon' + (page.class ? ` ${page.class}` : '')}>
            { pageName == 'direct_messages' && directMessagesUnseen > 0 && 
              <div className='unseen'>{Math.min(directMessagesUnseen, 99)}</div> 
            }
            { page.image_url && <img src={page.image_url} />}
            { page.fa_class && <i className={'fa fa-solid ' + page.fa_class}></i>}
          </div>
          <span>{page.title}</span>
        </a>
      </li>
    })
  }

  return <ul className='sidebar-menu'>{pageLinks()}</ul>
}

SideBar.propTypes = {
  pages: PropTypes.object.isRequired,
  directMessagesUnseen: PropTypes.number,
  directMessagesSubscribe: PropTypes.func.isRequired,
  directMessagesUnsubscribe: PropTypes.func.isRequired,
}

export default SideBar
